import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// Styled.
import * as S from './styled';

const Exception = ({ eventId }) => {
  const { t } = useTranslation();

  return (
    <S.Wrapper>
      <S.Title>{t('core:error.exception.title')}</S.Title>
      <S.Description>{t('core:error.exception.message')}</S.Description>
      {eventId && (
        <S.Identifier>
          {t('core:error.exception.reference')}
          {': '}
          {eventId}
        </S.Identifier>
      )}
      <S.Cool />
    </S.Wrapper>
  );
};

Exception.propTypes = {
  eventId: PropTypes.string,
};

export default Exception;
